import { createContext, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLocalStorage } from '../../store/storage';
import { updateUser } from '../../store/user';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useLocalStorage({ key: 'user', value: null });
	const [employer, setEmployer] = useLocalStorage({ key: 'employer', value: null });
	const userStore = useSelector((state) => state.user);
	const dispatch = useDispatch();
	if(!userStore.user){
	  dispatch(updateUser(user));
	}
	
	const navigate = useNavigate();

	const logout = () => {
		setUser(null);
		setEmployer(null);
		navigate('/login');
	}

	const value = useMemo(() => ({
	  user,
	  employer,
	  logout
	}), [user, employer, logout])

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
	return useContext(AuthContext);
}